import produce from "immer";
import { UserMappingActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialUserMappingState } from "./userMapping.types";
import {
  CLEAR_USER_MAPPING_STATE,
  FETCH_USER_MAP_DETAILS_FAILURE,
  FETCH_USER_MAP_DETAILS_PROGRESS,
  FETCH_USER_MAP_DETAILS_SUCCESS,
  FETCH_USER_MAP_LIST_FAILURE,
  FETCH_USER_MAP_LIST_PROGRESS,
  FETCH_USER_MAP_LIST_SUCCESS,
} from "./userMappingActions";
import { LoadState } from "../../constants/enums";

export const userMappingReducer = (
  state: IStoreState["userMapping"] = initialUserMappingState,
  action: UserMappingActions
) => {
  switch (action.type) {
    case FETCH_USER_MAP_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.userMapListLoading = LoadState.InProgress;
        draftState.userMapList = initialUserMappingState["userMapList"];
      });
      return newState;
    }

    case FETCH_USER_MAP_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.userMapListLoading = LoadState.Loaded;
        draftState.userMapList = data;
        draftState.userMapListTotalRecords = totalRecords;
      });
      return newState;
    }

    case FETCH_USER_MAP_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.userMapListLoading = LoadState.Failed;
        draftState.userMapList = initialUserMappingState["userMapList"];
        draftState.userMapListTotalRecords = 0;
      });
      return newState;
    }

    case FETCH_USER_MAP_DETAILS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.userMapDetailsLoading = LoadState.InProgress;
        draftState.userMapDetailsList = initialUserMappingState["userMapDetailsList"];
      });
      return newState;
    }

    case FETCH_USER_MAP_DETAILS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.userMapDetailsLoading = LoadState.Loaded;
        draftState.userMapDetailsList = data;
        draftState.userMapDetailsTotalRecords = totalRecords;
      });
      return newState;
    }

    case FETCH_USER_MAP_DETAILS_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.userMapDetailsLoading = LoadState.Failed;
        draftState.userMapDetailsList = initialUserMappingState["userMapDetailsList"];
        draftState.userMapDetailsTotalRecords = 0;
      });
      return newState;
    }

    case CLEAR_USER_MAPPING_STATE: {
      return initialUserMappingState;
    }

    default: {
      return state;
    }
  }
};
